export interface CategoryMeta {
  emoji: string;
  gradient: string;
  accentColor: string;
  bgColor: string;
  image: string;
  gif?: string;
  video?: string;
  shortDesc: string;
}

export const CATEGORY_META: Record<string, CategoryMeta> = {
  'Раздвижные электрокарнизы': {
    video: '/gifs/razdvig.mp4',
    emoji: '🎡',
    gradient: 'from-blue-600 to-indigo-700',
    accentColor: 'text-blue-600',
    bgColor: 'bg-blue-50',
    image: '/gifs/razdvig_thumb.jpg',
    shortDesc: 'Бесшумные моторизованные карнизы для штор любого типа',
  },
  'Рулонные шторы': {
    video: '/gifs/rulonnie.mp4',
    emoji: '🌀',
    gradient: 'from-slate-600 to-gray-800',
    accentColor: 'text-slate-600',
    bgColor: 'bg-slate-50',
    image: '/gifs/rulonnie_thumb.jpg',
    shortDesc: 'Компактные шторы с электроприводом и умным управлением',
  },
  'Римские шторы': {
    video: '/gifs/rimskaya.mp4',
    emoji: '🏛',
    gradient: 'from-amber-600 to-orange-700',
    accentColor: 'text-amber-600',
    bgColor: 'bg-amber-50',
    image: '/gifs/rimskaya_thumb.jpg',
    shortDesc: 'Классические складчатые шторы с моторизацией',
  },
  'Плиссе': {
    video: '/gifs/plisse.mp4',
    emoji: '📐',
    gradient: 'from-teal-500 to-cyan-700',
    accentColor: 'text-teal-600',
    bgColor: 'bg-teal-50',
    image: '/gifs/plisse_thumb.jpg',
    shortDesc: 'Плиссированные шторы для нестандартных проёмов',
  },
  'Японские шторы': {
    video: '/gifs/japan.mp4',
    emoji: '🎌',
    gradient: 'from-rose-500 to-pink-700',
    accentColor: 'text-rose-600',
    bgColor: 'bg-rose-50',
    image: '/gifs/japan_thumb.jpg',
    shortDesc: 'Минималистичные панельные шторы в японском стиле',
  },
  'Лифт-система': {
    video: '/gifs/lift.mp4',
    emoji: '⬆️',
    gradient: 'from-violet-600 to-purple-800',
    accentColor: 'text-violet-600',
    bgColor: 'bg-violet-50',
    image: '/gifs/lift_thumb.jpg',
    shortDesc: 'Системы подъёма штор с электроприводом',
  },
  'Пергола': {
    video: '/gifs/pergola.mp4',
    emoji: '🌿',
    gradient: 'from-green-600 to-emerald-800',
    accentColor: 'text-green-600',
    bgColor: 'bg-green-50',
    image: '/gifs/pergola_thumb.jpg',
    shortDesc: 'Уличные перголы с моторизованным управлением',
  },
  'Жалюзи': {
    video: '/gifs/jalyouziii.mp4',
    emoji: '🪟',
    gradient: 'from-sky-500 to-blue-700',
    accentColor: 'text-sky-600',
    bgColor: 'bg-sky-50',
    image: '/gifs/jalyouziii_thumb.jpg',
    shortDesc: 'Горизонтальные и вертикальные жалюзи с автоматикой',
  },
  'Маркиза и ZIP-система': {
    video: '/gifs/markiza.mp4',
    emoji: '⛱',
    gradient: 'from-orange-500 to-red-700',
    accentColor: 'text-orange-600',
    bgColor: 'bg-orange-50',
    image: '/gifs/markiza_thumb.jpg',
    shortDesc: 'Маркизы и ZIP-шторы для террас и фасадов',
  },
  'ZIP-система': {
    video: '/gifs/zip.mp4',
    emoji: '🛡️',
    gradient: 'from-orange-500 to-red-700',
    accentColor: 'text-orange-600',
    bgColor: 'bg-orange-50',
    image: '/gifs/zip_thumb.jpg',
    shortDesc: 'ZIP-системы для защиты от солнца и ветра',
  },
  'Маркиза': {
    video: '/gifs/markiza.mp4',
    emoji: '⛱',
    gradient: 'from-amber-500 to-orange-700',
    accentColor: 'text-amber-600',
    bgColor: 'bg-amber-50',
    image: '/gifs/markiza_thumb.jpg',
    shortDesc: 'Маркизы для террас, веранд и фасадов',
  },
  'Моторы': {
    emoji: '⚡',
    gradient: 'from-indigo-600 to-blue-800',
    accentColor: 'text-indigo-600',
    bgColor: 'bg-indigo-50',
    image: '/gifs/motor.png',
    shortDesc: 'Каталог моторов Onviz: протоколы, питание и подбор под задачи',
  },
};

export const DEFAULT_META: CategoryMeta = {
  emoji: '📦',
  gradient: 'from-gray-500 to-gray-700',
  accentColor: 'text-gray-600',
  bgColor: 'bg-gray-50',
  image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&q=80',
  shortDesc: 'Моторизованные системы управления светом',
};

export function getCategoryMeta(category: string): CategoryMeta {
  return CATEGORY_META[category] ?? DEFAULT_META;
}
